/** A short-lived, tab-local address; the destination still authorizes every read. */
const KEY = "imam:sign-in-return:v1";
const MAX_AGE_MS = 15 * 60 * 1000;
const MEMBER_PATH = /^\/(admin|instructor|student)(?:\/|$)/;

export function safeSignInReturn(value: unknown): string | null {
  if (typeof value !== "string" || value.length > 2048 || !MEMBER_PATH.test(value)
    || value.includes("\\") || [...value].some(char => char.charCodeAt(0) <= 32)) return null;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || !MEMBER_PATH.test(url.pathname)) return null;
    // Authentication credentials never belong in the stored return address.
    const fragment = new URLSearchParams(url.hash.slice(1));
    for (const name of ["access_token", "refresh_token", "provider_token", "id_token", "token", "code"]) {
      if (url.searchParams.has(name) || fragment.has(name)) return null;
    }
    return url.pathname + url.search + url.hash;
  } catch { return null; }
}

export function rememberSignInReturn(value: string): void {
  const path = safeSignInReturn(value);
  if (!path) return;
  try { window.sessionStorage.setItem(KEY, JSON.stringify({ path, expires: Date.now() + MAX_AGE_MS })); } catch { /* storage may be unavailable */ }
}

export function readSignInReturn(): string | null {
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(KEY) ?? "null") as { path?: unknown; expires?: unknown } | null;
    if (typeof saved?.expires !== "number" || saved.expires <= Date.now()
      || saved.expires > Date.now() + MAX_AGE_MS) return null;
    return safeSignInReturn(saved.path);
  } catch { return null; }
}

export function clearSignInReturn(): void {
  try { window.sessionStorage.removeItem(KEY); } catch { /* storage may be unavailable */ }
}
